var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = { class: "flex items-center text-black text-lg" };
var _hoisted_2 = { style: { "margin-bottom": "4%" } };
var _hoisted_3 = ["value"];
var _hoisted_4 = { class: "flex justify-between mt-2" };
import { storeToRefs } from 'pinia';
import { patientStore } from '@/store/patient';
import { Modal } from "flowbite-vue";
import AlertModal from "@/components/AlertModalFeedback.vue";
import { ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfModal',
    props: {
        index: Number,
        table: String,
        idtype: String,
        idConf: String
    },
    emits: ["closeModal", "refreshPage"],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var props = __props;
        var store = patientStore();
        var patient = storeToRefs(store).patient;
        function cancelConfidenzialita() {
            emit('closeModal');
        }
        var alertModal = ref(null);
        var showLoading = ref(false);
        function saveData() {
            var _a;
            return __awaiter(this, void 0, void 0, function () {
                var userInput;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            patient.value[props.table][props.index].id_paziente = patient.value.id_paziente;
                            return [4 /*yield*/, ((_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Salvare le modifiche ? ", true))];
                        case 1:
                            userInput = _b.sent();
                            if (!userInput) return [3 /*break*/, 3];
                            showLoading.value = true;
                            return [4 /*yield*/, store.savePaziente(props.table, patient.value[props.table][props.index][props.idtype])
                                    .then(function () {
                                    var _a;
                                    showLoading.value = false;
                                    emit('closeModal');
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Confidenzialita aggiornato con successo! ", false);
                                    if (props.table == 'diagnosi') {
                                        store.fetchDiagnosi();
                                    }
                                    else if (props.table.includes('esami')) {
                                        store.fetchEsami();
                                    }
                                    else if (props.table.includes('emergenza')) {
                                        store.fetchEmergencyContact();
                                    }
                                })
                                    .catch(function (res) {
                                    var _a;
                                    showLoading.value = false;
                                    emit('closeModal');
                                    (_a = alertModal.value) === null || _a === void 0 ? void 0 : _a.openModal("Errore durante la modifica il confidenzialita " + res, false);
                                    store.fetchEmergencyContact();
                                })];
                        case 2:
                            _b.sent();
                            _b.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            });
        }
        return function (_ctx, _cache) {
            var _component_LoadingComponent = _resolveComponent("LoadingComponent");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(_unref(Modal), {
                    onClose: _cache[1] || (_cache[1] = function ($event) { return (_ctx.$emit('closeModal')); })
                }, {
                    header: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('Seleziona il livello di confidenzialita: ')), 1)
                    ]; }),
                    body: _withCtx(function () { return [
                        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t("Livello di confidenzialità *")), 1),
                        _withDirectives(_createElementVNode("select", {
                            id: "confidenzialità",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((_unref(patient)[props.table][props.index][props.idConf]) = $event); }),
                            class: "bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(patient).liveli_confidencialita, function (item, key) {
                                return (_openBlock(), _createElementBlock("option", {
                                    value: item.id_livello_confidenzialita,
                                    key: key
                                }, _toDisplayString(item.confidenzialita_descrizione), 9, _hoisted_3));
                            }), 128))
                        ], 512), [
                            [_vModelSelect, _unref(patient)[props.table][props.index][props.idConf]]
                        ])
                    ]; }),
                    footer: _withCtx(function () { return [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("button", {
                                onClick: cancelConfidenzialita,
                                type: "button",
                                class: "text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                            }, _toDisplayString(_ctx.$t('Annulla')), 1),
                            _createElementVNode("button", {
                                onClick: saveData,
                                type: "button",
                                class: "text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                            }, _toDisplayString(_ctx.$t('Salva')), 1)
                        ])
                    ]; }),
                    _: 1
                }),
                _createVNode(AlertModal, {
                    ref_key: "alertModal",
                    ref: alertModal
                }, null, 512),
                (showLoading.value)
                    ? (_openBlock(), _createBlock(_component_LoadingComponent, { key: 0 }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
